import React from 'react';
import BaseLayout from "@/Layouts/BaseLayout";
import MainCarousel from "@/Pages/Site/Main/MainCarousel";
import Teasers from "@/Pages/Site/Main/Teasers";
import BestPriceCarousel from "@/Pages/Site/Main/BestPriceCarousel";
import HitsCarousel from "@/Pages/Site/Main/HitsCarousel";
import CollectionsCarousel from "@/Pages/Site/Main/CollectionsCarousel";
import CategoriesCarousel from "@/Pages/Site/Main/CategoriesCarousel";
import BlogCarousel from "@/Pages/Site/Main/BlogCarousel";
import '@/Scss/Site/Main/index.scss';

const Main = (props) => {
    return (
        <BaseLayout {...props}>
            <section className={`section section--mainPage`}>
                <div className={`container`}>
                    <div className={`sliderContainer`}>
                        <MainCarousel {...props} />
                        <Teasers {...props} />
                    </div>
                </div>
                <BestPriceCarousel {...props} />
                <HitsCarousel {...props} />
                <CollectionsCarousel {...props} />
                <CategoriesCarousel {...props} />
                <BlogCarousel {...props} />
            </section>
        </BaseLayout>
    );
};

export default Main;
